import { Component } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../common/app.settings';
import { AuthenticationService } from '../../services/authentication.service';
import { DeviceService } from '../../services//device.service';
import { DeviceModel } from '../../models/device.model';

@Component({
    selector: 'devices',
    templateUrl: './devices.component.html'
})
export class DevicesComponent {
    deviceList: Array<DeviceModel>;
    isDataAvailable = false;

    constructor(private http: Http, private authService: AuthenticationService, private deviceService: DeviceService) {
    }

    ngOnInit() {
        let headers = new Headers({ 'Authorization': 'Bearer ' + this.authService.token });
        let options = new RequestOptions({ headers: headers });
 
        this.deviceService.getDevices()
        .subscribe(devices => {
            this.deviceList = devices.data;
            for (let device of this.deviceList) {
                device.checked = device.value == "0" ? false : true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/devices/devices.component.ts